module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-ipad-19531be05a2768fc117aa23e426998e8.png";